export default __webpack_public_path__ + "static/media/landingImage.c7c75ae6.png";